import { ReactNode } from "react";
import { useVerticalScroll } from "./fade-vertical-scroll.hooks";
import { StyledScrollable, StyledWrapper } from "./fade-vertical-scroll.styles";
import { MDSFadeBottom } from "./fade-bottom";
import { MDSFadeTop } from "./fade-top";

export interface MDSFadeVerticalScrollProps extends React.HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

export const MDSFadeVerticalScroll = ({
  children,
  className,
  ...rest
}: MDSFadeVerticalScrollProps) => {
  const { scrollContainerRef, scrollState, handleScroll } = useVerticalScroll();

  return (
    <StyledWrapper data-mds-name="fade-vertical-scroll">
      <MDSFadeTop visible={scrollState.topVisible} />
      <StyledScrollable
        {...rest}
        className={className}
        ref={scrollContainerRef}
        onScroll={handleScroll}
      >
        {children}
      </StyledScrollable>
      <MDSFadeBottom visible={scrollState.bottomVisible} />
    </StyledWrapper>
  );
};
